import React, { Component } from 'react'

import Image from 'components/ui/Image/Image'
import PlaceholderImage from 'components/ui/PlaceholderImage/PlaceholderImage'


class ImageWithPlaceholderFallback extends Component {

  state = {
    isError: false,
  }

  handleImageError = () => {
    this.setState({
      isError: true,
    })
  }

  render() {
    const { isError } = this.state

    if (isError) {
      return (
        <PlaceholderImage {...this.props} />
      )
    }

    return (
      <Image {...this.props} onError={this.handleImageError} />
    )
  }
}


export default ImageWithPlaceholderFallback
